const selectedBCT = data => ({
  type: 'UPDATE_SELECTED_BCT',
  data,
});

export default selectedBCT;



// WEBPACK FOOTER //
// ./src/Actions/Dashboard/selectedBCT.js